<template>
  <div>
    <DropdownItem
      class="el-dropdown-menu__item--user"
      data-test="user-menu-info"
    >
      <div class="dropdown-menu__box">
        <i
          class="icon icon-user-line"
          v-if="!showInDrawer"
        />
        <div class="dropdown-menu__box-content">
          <div
            class="text--lg text--semibold"
            id="subscription-email"
          >
            {{ user.email }}
          </div>
          <div class="text--secondary-color my-4">
            <small v-if="isSubscriptionPayed">
              <strong>{{ user.current_plan_name_decorated | uppercase }}</strong>
              <span v-if="isTarifLifetime">
                {{ $t('header.lifetime') }}
              </span>
              <span v-else>
                {{ $t('header.activeUntil') }}
                {{ user.active_until | formatDate(dateFormats.dateFns) }}
              </span>
            </small>
            <small v-else>
              {{ $t('header.expired') }}
              {{ user.active_until | formatDate(dateFormats.dateFns) }}
            </small>
          </div>
          <router-link
            @click.native="handleClick"
            class="text--semibold text--lg"
            :to="{ name: PATH_ORDER }"
          >
            {{ isTarifLifetime ? $t('header.upgradeToPremium') : $t('header.extendTarif') }}
          </router-link>
        </div>
      </div>
    </DropdownItem>

    <CtaBoxMini
      data-test="upgade-tarif"
      v-if="!userHasPremiumPlan"
    />

    <Divider />
    <DropdownItem
      command="showBillingSettings"
      icon="pin"
      data-test="user-menu-billing-settings"
    >
      {{ $t('header.billingSettings') }}
    </DropdownItem>

    <Divider />
    <DropdownItem
      command="showPasswordSettings"
      icon="key"
      data-test="user-menu-password-settings"
    >
      {{ $t('header.passwordSettings') }}
    </DropdownItem>

    <Divider />
    <DropdownItem
      command="showGeneralSettings"
      icon="cog"
      data-test="user-menu-general-settings"
    >
      {{ $t('header.generalSettings') }}
    </DropdownItem>

    <Divider />
    <DropdownItem
      command="showEmailsSettings"
      icon="send-line"
      data-test="user-menu-email-settings"
    >
      {{ $t('header.emailsSettings') }}
    </DropdownItem>

    <Divider v-if="config.sequences.visible" />
    <DropdownItem
      command="showSequencesSettings"
      icon="number"
      data-test="user-menu-sequences-settings"
      v-if="config.sequences.visible"
    >
      {{ $t('header.sequencesSettings') }}
    </DropdownItem>

    <Divider v-if="userHasPremiumPlan && isOwner" />
    <DropdownItem
      v-if="userHasPremiumPlan && isOwner"
      command="showUsersPermitionsSettings"
      icon="users"
      data-test="user-menu-permitions-settings"
    >
      {{ $t('header.usersPermitionsSettings') }}
    </DropdownItem>

    <Divider v-if="isEetSite && userHasPremiumPlan && isEetEnabled" />
    <DropdownItem
      v-if="isEetSite && userHasPremiumPlan && isEetEnabled"
      command="showEetDialog"
      icon="eet"
    >
      {{ $t('header.eetSettings') }}
    </DropdownItem>

    <Divider />
    <DropdownItem
      command="logout"
      data-test="dropdown_logout"
      icon="sign-out-new"
    >
      {{ $t('header.logout') }}
    </DropdownItem>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { PATH_ORDER } from '~/router';
import { accountConfig } from '~/config/accountConfig';

export default {
  components: {
    CtaBoxMini: () => import('../../../components/CtaBoxMini.vue'),
  },
  props: {
    showInDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    PATH_ORDER,
  }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['userHasPremiumPlan', 'isTarifLifetime', 'isOwner']),
    ...mapGetters('env', ['dateFormats']),
    ...mapState('config', {
      isEetSite: state => state.global['eet_enabled?'],
      isEetEnabled: state => state.subscription['eet_enabled?'],
    }),
    config() {
      return this.$i18n.locale === 'en' ? accountConfig.usa : accountConfig.default;
    },
    isSubscriptionPayed() {
      return !!this.user.current_plan_name;
    },
  },
  methods: {
    handleClick() {
      this.$emit('handle-drawer-toggle');
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu__box {
  display: flex;
  border-radius: 8px;
  background-color: $--color-background;
  padding: 8px 12px;
  width: 100%;

  :deep() {
    & > .icon {
      font-size: 24px;
      margin-right: 8px;
      color: #097fb5;
    }

    small {
      font-size: rem(14px);
    }
  }
}

.dropdown-menu__box-content {
  margin-top: 3px;
}

:deep() {
  .el-dropdown-menu__item:not(.el-dropdown-menu__item--user) {
    padding: 8px 12px 8px 40px;
    margin: 4px 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .el-dropdown-menu__content {
    text-decoration: none;
  }

  .el-dropdown-menu__item--with-icon {
    .icon {
      left: 12px;
      top: 50%;
      transform: translateY(calc(-50% + 1px));
      font-size: 20px;
    }
  }

  .el-divider {
    display: none;
  }
}

.dropdown--show-in-drawer {
  width: 100%;
  padding-top: 8px;

  .el-dropdown-menu__item:not(.el-dropdown-menu__item--user) {
    padding: 12px 12px 12px 48px;
    border-radius: 8px;

    &:hover,
    &:focus,
    &:active {
      background-color: $--color-background;
    }
  }

  .el-divider {
    margin: 8px 0;
    display: block;
  }
}
</style>
